import { BaseItemModel } from "@webapp/core/abstracts/models/base-item.model";
import { WhiteboardState } from "@webapp/whiteboards/models/whiteboard-state.model";
import { WhiteboardAccess } from "@webapp/whiteboards/models/whiteboard-access.model";
import { BaseDtoModel } from "@webapp/core/abstracts/models/base-dto.model";
// TODO: These models are intended just for the Example of Facades and their usage,
//  the models should be migrated when the module migration has started
export class Whiteboard extends BaseItemModel {
  id!: string;
  access!: WhiteboardAccess;
  createdAt: Date;
  createdById: string;
  name: string;
  ownerId: string;
  picture: string;
  state!: WhiteboardState;
}

export class WhiteboardDto extends BaseDtoModel {
  items: string[] = [];
}
